import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function PhoneRepairRequiredRoute() {
  const { phoneRepair } = useAuth();

  if (phoneRepair?.shouldShow) {
    return <Navigate to="/phone-repair" replace preventScrollReset />;
  }

  return <Outlet />;
}

